import { useMemo } from "react";
import type { Channel, SourceRow } from "../../types/analytics";
import { CHANNEL_COLOR, int, pctStr } from "../../lib/analyticsCalc";

interface SourcesCardProps {
  sources: SourceRow[];
  channels: Record<Channel, boolean>;
  onSeeAll: () => void;
}

export function SourcesCard({ sources, channels, onSeeAll }: SourcesCardProps) {
  const visible = useMemo(
    () =>
      sources
        .filter((s) => channels[s.channel])
        .slice()
        .sort((a, b) => b.sessions - a.sessions)
        .slice(0, 8),
    [sources, channels]
  );
  const max = visible.length ? visible[0].sessions : 1;

  return (
    <div className="an-sources-card">
      <div className="an-sources-head">
        <div className="an-sources-title">流入元</div>
        <div className="an-sources-hint">アクセス / 転換率</div>
      </div>
      <div className="an-source-list">
        {visible.length === 0 && <div className="an-sources-hint">データがありません。</div>}
        {visible.map((s) => (
          <div className="an-source-row" key={`${s.channel}-${s.source}`}>
            <div className="an-source-top">
              <span className="an-source-dot" style={{ background: CHANNEL_COLOR[s.channel] }} />
              <span className="an-source-name">{s.source}</span>
              {s.is_ad && <span className="an-source-badge">広告</span>}
              <span className="an-source-sessions">{int(s.sessions)}</span>
              <span className="an-source-cvr">{s.orders != null ? pctStr(s.orders, s.sessions) : "—"}</span>
            </div>
            <div className="an-bar-track">
              <div className="an-bar-fill" style={{ width: `${max ? (s.sessions / max) * 100 : 0}%`, background: CHANNEL_COLOR[s.channel], opacity: 0.8 }} />
            </div>
          </div>
        ))}
      </div>
      <button className="an-sources-more" onClick={onSeeAll}>
        すべての流入元を見る
      </button>
    </div>
  );
}
